import React, { useEffect } from 'react';
import useScanDetection from 'use-scan-detection';

function ScanDetector({ onBarcodeScan }) {


    useScanDetection({
        onComplete: (code) => {
            let scanVal = code;
            scanVal = scanVal.replaceAll("Shift", "");
            onBarcodeScan(scanVal);
        }        
    })
    return null;

}

export default ScanDetector;